import { render, staticRenderFns } from "./ReadAboutEn.vue?vue&type=template&id=75205a74"
import script from "./ReadAboutEn.vue?vue&type=script&lang=js"
export * from "./ReadAboutEn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports